export default "__VITE_ASSET__BSkOgY8q__"